import { MessageCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { SOCIALS, WHATSAPP } from "@/lib/brand";

const CTA_MESSAGE = "مرحباً، أريد بدء مشروع جديد مع TRBD";

const MegaCTA = () => {
    const whatsappUrl = `${WHATSAPP.sy.url}?text=${encodeURIComponent(CTA_MESSAGE)}`;

    return (
        <section className="py-20 md:py-32" id="contact" dir="rtl">
            <div className="container mx-auto px-6">
                <div
                    className="relative overflow-hidden rounded-[40px] md:rounded-[48px] px-6 md:px-8 py-16 md:py-32 text-center"
                    style={{
                        background:
                            "linear-gradient(145deg, hsl(260 90% 65% / 0.12), hsl(190 90% 50% / 0.06))",
                        border: "1px solid hsl(260 90% 65% / 0.25)",
                    }}
                >
                    {/* Rotating conic halo */}
                    <div
                        aria-hidden
                        className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[120%] aspect-square animate-halo-v2 pointer-events-none opacity-40"
                        style={{
                            background:
                                "conic-gradient(from 0deg, transparent 0%, hsl(260 90% 65% / 0.4) 25%, transparent 50%, hsl(190 90% 50% / 0.4) 75%, transparent 100%)",
                            filter: "blur(60px)",
                        }}
                    />
                    <div
                        aria-hidden
                        className="absolute inset-0 pointer-events-none"
                        style={{
                            background:
                                "radial-gradient(ellipse at center, transparent 0%, hsl(240 33% 4% / 0.3) 70%)",
                        }}
                    />

                    <div className="relative z-10">
                        <h2 className="font-v2-hero text-5xl md:text-7xl lg:text-8xl text-white mb-8">
                            هل أنت مستعد{" "}
                            <span className="bg-gradient-to-r from-primary to-secondary bg-clip-text text-transparent">
                                للقفزة؟
                            </span>
                        </h2>
                        <p className="text-lg md:text-2xl text-white/70 max-w-2xl mx-auto mb-12 leading-relaxed font-medium">
                            أخبرنا عن فكرتك. رد أولي خلال 24 ساعة، عرض سعر مفصل خلال 3 أيام.
                        </p>

                        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
                            <a href={whatsappUrl} target="_blank" rel="noopener noreferrer" data-cursor="hover">
                                <Button
                                    size="lg"
                                    className="h-16 px-10 text-lg rounded-full bg-[#128C7E] text-white hover:bg-[#075E54] font-bold gap-3"
                                >
                                    <MessageCircle className="w-5 h-5" />
                                    ابدأ عبر واتساب
                                </Button>
                            </a>
                            <a
                                href={SOCIALS.telegram.url}
                                target="_blank"
                                rel="noopener noreferrer"
                                data-cursor="hover"
                            >
                                <Button
                                    size="lg"
                                    variant="outline"
                                    className="h-16 px-10 text-lg rounded-full border-white/15 hover:bg-white/5 text-white font-bold gap-3"
                                >
                                    بوت Telegram
                                </Button>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default MegaCTA;
